/* global Stage */

export enum Stage {
    INT = 'INT', TEST = 'TEST', PROD = 'PROD', // eslint-disable-line no-undef
}

export default Stage
